import { render, staticRenderFns } from "./DownTimeTopBottom.vue?vue&type=template&id=60aa24a6&scoped=true"
import script from "./DownTimeTopBottom.vue?vue&type=script&lang=js"
export * from "./DownTimeTopBottom.vue?vue&type=script&lang=js"
import style0 from "./DownTimeTopBottom.vue?vue&type=style&index=0&id=60aa24a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa24a6",
  null
  
)

export default component.exports